// PDP landing COD: pack de unidades, selector de variantes, skip-cart y sticky ATC.
(function () {
  // Pack de unidades: al seleccionar una tarjeta, fija la VARIANTE-pack del form.
  function initQuantityBreaks(root, form) {
    var qb = root.querySelector('[data-me-qb]');
    if (!qb) return;

    // input cantidad real (Shopify lee name="quantity"); lo creamos si no existe
    var qtyInput = form.querySelector('input[name="quantity"]');
    if (!qtyInput) {
      qtyInput = document.createElement('input');
      qtyInput.type = 'hidden';
      qtyInput.name = 'quantity';
      qtyInput.value = '1';
      form.appendChild(qtyInput);
    }
    // input variante (Shopify/Releasit leen name="id"): cada pack es una VARIANTE
    // con su propio precio, así que al elegir un pack cambiamos la variante, no la
    // cantidad. Cantidad siempre = 1.
    var idInput = form.querySelector('.me-product__variant-id') || form.querySelector('input[name="id"]');

    function sync() {
      var checked = qb.querySelector('input[name="me-qty"]:checked');
      var vid = checked ? checked.getAttribute('data-variant-id') : null;
      if (vid && idInput) idInput.value = vid;
      qtyInput.value = '1';
      qb.querySelectorAll('.me-qb__card').forEach(function (c) {
        var r = c.querySelector('input[name="me-qty"]');
        c.classList.toggle('is-selected', !!(r && r.checked));
      });
    }

    qb.addEventListener('change', function (e) {
      if (e.target && e.target.name === 'me-qty') sync();
    });
    sync();
  }

  // Selector de variantes reales (color/talla): actualiza input id, precio y foto.
  // Excluyente con el pack de unidades (un producto tiene variantes O packs).
  function initVariantPicker(root, form) {
    var vp = root.querySelector('[data-me-vp]');
    if (!vp) return;
    var dataEl = vp.querySelector('[data-me-vp-data]');
    if (!dataEl) return;
    var variants;
    try { variants = JSON.parse(dataEl.textContent); } catch (e) { return; }
    var idInput = form.querySelector('.me-product__variant-id') || form.querySelector('input[name="id"]');
    var priceEl = root.querySelector('.me-offer__price');
    var compareEl = root.querySelector('.me-offer__compare');
    var saveEl = root.querySelector('.me-offer__save');
    var imgEl = root.querySelector('.me-product__image');

    function selectedValues() {
      var vals = [];
      vp.querySelectorAll('.me-vp__group').forEach(function (g, i) {
        var r = g.querySelector('input[name="me-opt-' + i + '"]:checked');
        vals.push(r ? r.value : null);
      });
      return vals;
    }

    function findVariant(vals) {
      for (var i = 0; i < variants.length; i++) {
        var v = variants[i], match = true;
        for (var j = 0; j < vals.length; j++) {
          if (vals[j] !== null && v.options[j] !== vals[j]) { match = false; break; }
        }
        if (match) return v;
      }
      return null;
    }

    // CARRIL ALINEADO A LA IZQUIERDA, Y SE SIGUE ELIGIENDO CON EL DEDO.
    //
    // Era una rueda tipo iPhone: la tarjeta CENTRADA quedaba elegida, y para que la
    // primera y la última pudieran llegar al centro había que rellenar los lados con
    // `clientWidth/2 - ancho/2` —91,5 px medidos en la landing del tenis—. Ese relleno
    // es lo que dejaba la tarjeta activa y un 60% de la siguiente colgando del borde:
    // «las variantes se muestran cortadas».
    //
    // Lo que NO había que perder es el gesto: «pasabas con el dedo y el selector tomaba
    // el que está al frente». El primer intento lo cambió por «desliza para ver, toca
    // para elegir» y él lo echó de menos en cuanto lo vio. No hacía falta: lo que
    // cambia con la alineación a la izquierda no es el gesto, es DÓNDE está el frente.
    // En la rueda el frente era el centro; aquí es el borde de lectura, o sea la
    // izquierda del carril. Se sigue eligiendo al deslizar, y nada queda cortado.
    var MARGEN_CARRIL = 14; // el mismo relleno lateral que pone me-product.css

    function bringIntoView(track, el, instant) {
      // Scroll PROGRAMÁTICO: se abre una ventana de ignorar para que la selección en
      // vivo no elija tarjetas intermedias mientras la banda se acomoda sola (al
      // abrir/cerrar el formulario COD, al redimensionar, al cargar las fotos lazy).
      // Sin esto, abrir el formulario cambiaba la talla él solo.
      track.__meIgnoreUntil = Date.now() + (instant ? 300 : 800);
      // Por DIFERENCIA en pantalla, por lo mismo que `alFrente`: `offsetLeft` cuenta
      // desde el ancestro posicionado y con las flechas dentro de la fila sobra el ancho
      // de la flecha.
      var delta = el.getBoundingClientRect().left
                  - track.getBoundingClientRect().left - MARGEN_CARRIL;
      var left = Math.max(0, track.scrollLeft + delta);
      if (track.scrollTo) track.scrollTo({ left: left, behavior: instant ? 'auto' : 'smooth' });
      else track.scrollLeft = left;
    }

    function centerSelected(group, instant) {
      var track = group.querySelector('[data-me-vp-track]');
      var sel = group.querySelector('.me-vp__pill.is-selected');
      if (track && sel) bringIntoView(track, sel, instant);
    }

    // RELLENO AL FINAL, para que la ÚLTIMA tarjeta también pueda llegar al frente.
    //
    // Con «el frente es la izquierda», las últimas tarjetas se quedaban sin sitio: el
    // carril se acaba antes. Medido con tres colores de 133 px en un carril de 375: el
    // recorrido es de 70 px y llevar la segunda al frente pide 142, así que deslizando
    // solo se podía elegir la primera. Es el mismo problema que tenía la rueda con la
    // primera y la última —no podían centrarse— resuelto al otro lado.
    //
    // El relleno de la izquierda lo pone el CSS (14 px) porque es lo que se ve en
    // reposo. El de la derecha depende del ancho real del carril, así que se calcula
    // aquí: espacio VACÍO detrás de la última, que no corta nada.
    function padTrack(track) {
      var pills = track.querySelectorAll('.me-vp__pill');
      track.style.paddingLeft = '';
      track.classList.remove('me-vp__track--centrado');
      if (!pills.length) { track.style.paddingRight = ''; return; }

      // SI CABEN TODAS, VAN CENTRADAS Y SIN RELLENO.
      //
      // El relleno de la derecha existe para que la última tarjeta pueda llegar al
      // frente cuando hay que deslizar. Con dos colores no hay nada que deslizar, y
      // ese relleno —398 px medidos en la landing de la antorcha, sobre un carril de
      // 480— empujaba las dos pastillas contra el borde izquierdo dejando dos tercios
      // de la fila vacíos. Andrés lo vio como «el selector se ve descentrado», y lo
      // era: el hueco no lo pedía nada.
      var suma = 0;
      for (var i = 0; i < pills.length; i++) suma += pills[i].getBoundingClientRect().width;
      var gap = parseFloat(getComputedStyle(track).columnGap || '0') || 0;
      suma += gap * Math.max(0, pills.length - 1);
      if (suma <= track.clientWidth - MARGEN_CARRIL * 2) {
        track.style.paddingRight = '';
        track.classList.add('me-vp__track--centrado');
        return;
      }
      var ultima = pills[pills.length - 1].getBoundingClientRect().width;
      track.style.paddingRight = Math.max(
        MARGEN_CARRIL, Math.round(track.clientWidth - ultima - MARGEN_CARRIL)) + 'px';
    }

    function sync(skipCenter) {
      var v = findVariant(selectedValues());
      if (!v) return; // combinación inexistente: conserva la última válida
      if (idInput) idInput.value = v.id;
      if (priceEl) priceEl.textContent = v.price;
      if (compareEl) {
        if (v.compare) { compareEl.textContent = v.compare; compareEl.style.display = ''; }
        else compareEl.style.display = 'none';
      }
      if (saveEl) {
        if (v.save) {
          // El ahorro y el porcentaje van en piezas separadas: los estilos del precio
          // B, C y D esconden el porcentaje porque ya lo dicen con su sello.
          var ahorroEl = saveEl.querySelector('.me-offer__ahorro');
          var pctEl = saveEl.querySelector('.me-offer__pct');
          if (ahorroEl && pctEl) { ahorroEl.textContent = v.save; pctEl.textContent = ' · ' + v.pct + '% OFF'; }
          else saveEl.textContent = 'Ahorras ' + v.save + ' · ' + v.pct + '% OFF';
          saveEl.style.display = '';
        } else saveEl.style.display = 'none';
      }
      // El sello (B), la etiqueta (C y D) leen el porcentaje de la tarjeta.
      var offerEl = root.querySelector('.me-offer');
      if (offerEl) {
        if (v.save && v.pct) offerEl.setAttribute('data-pct', v.pct);
        else offerEl.removeAttribute('data-pct');
      }
      if (imgEl && v.image) {
        imgEl.removeAttribute('srcset');
        imgEl.src = v.image;
      }
      vp.querySelectorAll('.me-vp__pill').forEach(function (p) {
        var r = p.querySelector('.me-vp__radio');
        p.classList.toggle('is-selected', !!(r && r.checked));
      });
      vp.querySelectorAll('.me-vp__group').forEach(function (g) {
        // Título dinámico "Color: Verde" + centrar la tarjeta elegida
        var cur = g.querySelector('[data-me-vp-current]');
        var selR = g.querySelector('.me-vp__radio:checked');
        if (cur && selR) cur.textContent = selR.value;
        if (!skipCenter) centerSelected(g);
      });
    }

    // Cablear cada banda como rueda horizontal
    vp.querySelectorAll('.me-vp__group').forEach(function (g) {
      var track = g.querySelector('[data-me-vp-track]');
      if (!track) return;
      var pills = [].slice.call(track.querySelectorAll('.me-vp__pill'));
      var prev = g.querySelector('[data-me-vp-prev]');
      var next = g.querySelector('[data-me-vp-next]');

      // La referencia de «dónde estoy» es la tarjeta MARCADA. La usan las flechas: sin
      // rueda, «la más cercana al centro» ya no es la elegida.
      function actual() {
        return g.querySelector('.me-vp__pill.is-selected') || pills[0] || null;
      }

      // LA TARJETA QUE ESTÁ AL FRENTE. En la rueda era la del centro; con el carril
      // alineado a la izquierda es la que queda pegada al borde de lectura. Es la que
      // el dedo deja «en primera posición» al soltar, y la que el imán del `scroll-snap`
      // acaba de encajar ahí.
      // Se mide contra el BORDE REAL del carril, no con `offsetLeft`. `offsetLeft` es
      // relativo al ancestro posicionado, y con las flechas ‹ › dentro de la fila el
      // primer panel daba 50 en vez de 14: la cuenta se iba y no seleccionaba nada.
      // Las posiciones en pantalla no dependen de quién sea el ancestro.
      function alFrente() {
        var izq = track.getBoundingClientRect().left + MARGEN_CARRIL;
        var best = null, bd = Infinity;
        pills.forEach(function (p) {
          var d = Math.abs(p.getBoundingClientRect().left - izq);
          if (d < bd) { bd = d; best = p; }
        });
        return best;
      }

      // SELECCIÓN AL DESLIZAR, solo con GESTO DEL USUARIO. La tarjeta se marca en el
      // instante en que llega al frente mientras ÉL desliza. Los scrolls que no inicia
      // el usuario —centrado programático, reflow del formulario COD, resize, carga de
      // las fotos lazy— NO seleccionan: antes cambiaban la talla solos al abrir el
      // formulario, y esa protección se conserva tal cual.
      // La guardia contra ráfagas de `scroll` es el ÍNDICE ANTERIOR, no un
      // `requestAnimationFrame`. Con rAF, el oyente no hace nada si el navegador no está
      // pintando —una pestaña de fondo, un panel oculto— y además no se puede probar sin
      // pintar. Comparar un número es más barato y no depende de nadie.
      var ultimo = -1, interacting = false, endT;
      function userTakesControl() {
        interacting = true;
        track.__meIgnoreUntil = 0;  // el gesto manda sobre cualquier animación en curso
        clearTimeout(endT);
      }
      ['pointerdown', 'touchstart', 'wheel'].forEach(function (ev) {
        track.addEventListener(ev, userTakesControl, { passive: true });
      });
      track.addEventListener('scroll', function () {
        if (!interacting || Date.now() < (track.__meIgnoreUntil || 0)) return;
        clearTimeout(endT);
        endT = setTimeout(function () { interacting = false; }, 180);
        var b = alFrente();
        if (!b) return;
        var i = pills.indexOf(b);
        if (i === ultimo) return;
        ultimo = i;
        var r = b.querySelector('.me-vp__radio');
        if (r && !r.checked) { r.checked = true; sync(true); }
      }, { passive: true });

      // Flechas ‹ › (escritorio): seleccionan la tarjeta anterior/siguiente a la
      // ELEGIDA. Antes partían de la más cercana al centro, y sin rueda esa ya no es
      // la elegida: pulsar «›» podía saltarse un color o repetir el actual.
      function step(dir) {
        var i = Math.min(pills.length - 1, Math.max(0, pills.indexOf(actual()) + dir));
        var r = pills[i].querySelector('.me-vp__radio');
        if (r && !r.checked) { r.checked = true; sync(); }
        else bringIntoView(track, pills[i]);
      }
      if (prev) prev.addEventListener('click', function () { step(-1); });
      if (next) next.addEventListener('click', function () { step(1); });

      // Re-medir y re-centrar cuando cambie el layout: las fotos lazy de las
      // tarjetas cargan DESPUÉS del init y corren los anchos del track.
      function refresh() { padTrack(track); centerSelected(g, true); }
      refresh();
      window.addEventListener('resize', refresh);
      if (document.readyState !== 'complete') window.addEventListener('load', refresh);
      pills.forEach(function (p) {
        var img = p.querySelector('img');
        if (img && !img.complete) img.addEventListener('load', refresh, { once: true });
      });
    });

    // AISLAR el picker del tema base: temas OS 2.0 (ej. Horizon) escuchan los
    // 'change' de variantes a nivel documento y re-renderizan/morfean la página
    // → con nuestro template custom dejaban secciones EN BLANCO al elegir una
    // variante. Capture + stopPropagation: el evento nunca sale del picker.
    // Releasit no depende de este evento (lee input[name=id] al abrir el form).
    vp.addEventListener('change', function (e) {
      if (e.target && e.target.classList.contains('me-vp__radio')) {
        e.stopPropagation();
        sync(); // tocar una tarjeta: seleccionar + centrarla en su banda
      }
    }, true);
    sync(true);
    // primer render: centrar la selección inicial SIN animación
    vp.querySelectorAll('.me-vp__group').forEach(function (g) { centerSelected(g, true); });
  }

  function initSection(root) {
    var form = root.querySelector('#me-product-form, .me-product__form');
    if (!form) return;

    initQuantityBreaks(root, form);
    initVariantPicker(root, form);

    // ── Si la tienda vende con EasySell, el pedido se hace en SU formulario ──
    // Medido en una tienda real: con `hide_atc` activado, EasySell solo esconde el botón
    // de pago dinámico de Shopify; el «Agregar al carrito» del tema se queda a la vista.
    // O sea que junto a su botón de contra entrega quedaba una puerta al checkout normal.
    // Esconderlo rompería el sticky (que se muestra según dónde esté ese botón), así que
    // en vez de esconderlo se le cambia el destino: abre el formulario de EasySell.
    // Se mira la página, no una bandera: sin EasySell, todo sigue como siempre.
    function botonDeEasySell() {
      return document.querySelector('.es-popup-button-overwrite, .es-popup-button');
    }
    form.addEventListener('submit', function (e) {
      var es = botonDeEasySell();
      if (!es) return;
      e.preventDefault();
      e.stopImmediatePropagation();   // antes que el envío al carrito de más abajo
      es.click();
    }, true);

    var skipCart = root.getAttribute('data-skip-cart') === 'true';
    if (skipCart) {
      form.addEventListener('submit', function (e) {
        e.preventDefault();
        var btn = form.querySelector('[name="add"]');
        if (btn) btn.setAttribute('disabled', 'disabled');
        fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
          body: new URLSearchParams(new FormData(form)).toString()
        }).then(function (r) { return r.json(); })
          .then(function () { window.location.href = '/checkout'; })
          .catch(function () {
            if (btn) btn.removeAttribute('disabled');
            window.location.href = '/cart';
          });
      });
    }

    var sticky = root.querySelector('[data-me-sticky]');
    if (sticky) {
      var atcBtn = form.querySelector('[name="add"]');
      var stickyBtn = sticky.querySelector('[data-me-sticky-btn]');
      if (stickyBtn) stickyBtn.addEventListener('click', function () {
        // Con EasySell el pedido se hace en SU formulario. Enviar el del tema mandaría
        // al comprador al carrito, saltándose el pago contra entrega — y su config nos
        // pide esconder «Agregar al carrito», así que el botón que enviamos ni se ve.
        // Se mira la página, no una bandera: si EasySell no está, todo sigue igual.
        var es = document.querySelector('.es-popup-button-overwrite, .es-popup-button');
        if (es) { es.click(); return; }
        if (typeof form.requestSubmit === 'function') form.requestSubmit(atcBtn);
        else form.submit();
      });
      var onScroll = function () {
        var rect = atcBtn ? atcBtn.getBoundingClientRect() : null;
        var show = rect ? (rect.bottom < 0 || rect.top > window.innerHeight) : false;
        if (show) sticky.removeAttribute('hidden'); else sticky.setAttribute('hidden', '');
      };
      window.addEventListener('scroll', onScroll, { passive: true });
      onScroll();
    }
  }

  document.querySelectorAll('.me-product').forEach(initSection);
})();
